import { useContext } from "react";
import { Button } from "react-bootstrap";
import { DropContext } from "@src/core/contexts/drop";
import { Offer } from "@src/core/models/offer";
import * as Styles from "./styles";

interface Props {
  hoverText?: string | null;
  offer: Offer;
}

const OfferActionButton = ({ hoverText, offer }: Props): JSX.Element => {
  const { dropIsActive, dropIsExpired } = useContext(DropContext);

  return (
    <Styles.Wrapper>
      <Button className={hoverText ? "has-hover-text" : ""} variant="primary">
        <span className="button-text">
          {defineButtonMessage(offer, true, dropIsExpired)}
        </span>
        {hoverText && <span className="hover-text">{hoverText}</span>}
      </Button>
    </Styles.Wrapper>
  );
};

OfferActionButton.defaultProps = {
  hoverText: "Mint to buy",
};

const defineButtonMessage = (
  offer: Offer,
  dropIsActive?: boolean,
  dropIsExpired?: boolean
): string => {
  if (isSoldOut(offer)) return "Sold out";

  if (dropIsExpired) return "Drop Expired";

  if (!dropIsActive) return "Not Active";

  return "Mint now";
};

const isSoldOut = (offer: Offer): boolean => {
  return !Number(offer.availableCount);
};

export default OfferActionButton;
